import {
  GETVOUCHERTRANSACTIONDETAILSLIST_SUCCESS,
  GETVOUCHERTRANSACTIONDETAILSLIST_FAILED,
  RESET_GETVOUCHERTRANSACTIONDETAILSLIST,
  LOADING_GETVOUCHERTRANSACTIONDETAILSLIST,
  NETWORK_ERROR_GETVOUCHERTRANSACTIONDETAILSLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETVOUCHERTRANSACTIONDETAILSLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETVOUCHERTRANSACTIONDETAILSLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETVOUCHERTRANSACTIONDETAILSLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETVOUCHERTRANSACTIONDETAILSLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETVOUCHERTRANSACTIONDETAILSLIST:
      return (state = initialState);
    default:
      return state;
  }
};
